module.exports = __webpack_public_path__ + "media/images/home/celebrity-hoarders-b9d9904a15354ffe1006f32e548fb43d.jpg";